import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5001',
  withCredentials: true,
});

export interface User {
  id: string;
  googleId: string;
  email: string;
  name: string;
  domain: string;
  gender: 'male' | 'female';
  profileComplete: boolean;
  createdAt: string;
  updatedAt: string;
  photos?: Photo[];
}

export interface Photo {
  id: string;
  userId: string;
  url: string;
  order: number;
  createdAt: string;
}

export interface Rating {
  id: string;
  raterId: string;
  ratedUserId: string;
  rating: number;
  photoVersionSeen: number;
  createdAt: string;
  updatedAt: string;
}

export interface FeedUser {
  id: string;
  name: string;
  photos: Photo[];
  photoVersion: number;
}

export interface FeedResponse {
  users: FeedUser[];
  hasMore: boolean;
  total: number;
}

export interface SearchResult extends FeedUser {
  currentRating?: number;
}

export interface MyRatingsResponse {
  totalRatings: number;
  averageRating: number;
  ratings: Rating[];
}

// Auth
export const checkAuthStatus = () => api.get<{ authenticated: boolean; user?: User }>('/auth/status');
export const logout = () => api.post('/auth/logout');

// Profile
export const getMyProfile = () => api.get<User>('/profile/me');
export const updateProfile = (data: { name: string; gender?: 'male' | 'female' }) => api.put<User>('/profile/me', data);
export const uploadPhotos = (formData: FormData) => 
  api.post('/profile/photos', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

// Ratings
export const getFeed = (limit = 10, offset = 0) => 
  api.get<FeedResponse>(`/ratings/feed?limit=${limit}&offset=${offset}`);
export const submitRating = (data: { ratedUserId: string; rating: number; photoVersionSeen: number }) => 
  api.post<Rating>('/ratings/rate', data);
export const searchUsers = (query: string) => 
  api.get<SearchResult[]>(`/ratings/search?query=${encodeURIComponent(query)}`);
export const getMyRatings = () => api.get<MyRatingsResponse>('/ratings/my-ratings');

export default api;
